import type { Metadata, Viewport } from 'next'

import type { TBaseComponentProps } from '../../typings'

export const rootMetadata: Metadata = {
  title: {
    template: 'Segway | %s',
    default: 'Segway',
  },
  description: 'Segway',
  // icons: {
  //   icon: [{ url: '/favicon/favicon-2025.png', type: 'image/png', rel: 'icon' }],
  //   shortcut: [{ url: '/favicon/favicon-2025.png', type: 'image/png', rel: 'icon' }],
  //   apple: [
  //     {
  //       rel: 'apple-touch-icon',
  //       type: 'image/png',
  //       url: '/favicon/favicon-2025.png',
  //     },
  //   ],
  // },
  robots: process.env.NEXT_PUBLIC_ROBOTS_INDEX ?? '',
}

export const rootViewport: Viewport = {
  width: 'device-width',
  initialScale: 1,
  maximumScale: 1,
  userScalable: false,
  viewportFit: 'cover',
}

export default function RootLayout({ children }: TBaseComponentProps) {
  return children
}
